import { makeStyles } from '@admitkard/ccl';

export default makeStyles (()=> ({
  root:{
    '& *'  : {
      boxSizing: 'border-box',
      margin:'0px',
      padding:'0px',
    },
    width:'100%',
    '& h1' :{
      fontFamily: 'Poppins',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '1.5rem',
      lineHeight: '2.25rem',
      color: '#483287',
      marginBottom:'1rem',
      '@media screen and (min-width: 768px)' : {
        fontSize: '2rem',
        lineHeight: '3rem',
      }
    }
  },
  categoriesContainer:{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent:'center',
    width:'100%',
    '@media screen and (min-width: 1200px)' : {
      flexDirection:'row',
      alignItems:'center',
      justifyContent:'space-between',
      height:'100%',
    }
  },
  categoriesItemPrimary:{
    cursor: 'pointer',
    width:'100%',
    '@media screen and (min-width: 1200px)' : {
      width:'45%',
      maxWidth:'31.8125rem',
      marginRight:'6.125rem',
    },
  },
  categoriesItemSecondary:{
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width:'100%',
    '@media screen and (min-width: 1200px)' : {
      width:'50%',
      maxWidth:'37.1875rem',
    }
  },
  categoriesItem:{
    cursor: 'pointer',
    width:'100%',
    display: 'flex',
    alignItems: 'flex-start',
    paddingBottom:'1rem',
    borderBottom:'0.0625rem solid #E2E2E2',
    marginBottom:'1rem',
    '@media screen and (min-width: 1200px)' : {
      paddingBottom:'2rem',
      marginBottom:'2rem',
    }

  },
  categoryItemPrimary:{
    width:'100%',
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom:'1rem',
    paddingBottom:'1rem',
    borderBottom:'0.0625rem solid #E2E2E2',
    height:'fit-content',
    '@media screen and (min-width: 1200px)' : {
      paddingBottom:'0px',
      borderBottom:'none',
      flexDirection:'column',
      height:'fit-content',
    }
  },
  categoriesImgContainerPrimary:{
    minWidth: '5.625rem',
    height: '5.75rem',
    background: '#ECDAFF',
    borderRadius: '0.625rem',
    marginRight:'1rem',
    objectFit:'cover',
    '@media screen and (min-width: 1200px)' : {
      height: '19.9375rem',
      minWidth: '100%',
    }
  },
  categoriesImgContainer : {
    minWidth: '5.625rem',
    maxWidth: '5.625rem',
    height: '5.75rem',
    background: '#ECDAFF',
    borderRadius: '0.625rem',
    marginRight:'1rem',
    '@media screen and (min-width: 1200px)' : {
      height: '7.5625rem',
      minWidth: '7.5625rem',
      maxWidth: '7.5625rem',
    }
  },
  categoriesDetailsContainer:{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    minHeight:'5.75rem',
    '@media screen and (min-width: 1200px)' : {
      minHeight:'7.5625rem',
    }
  },
  categoriesDetailsContainerPrimary:{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  categoriesDetailTiltle:{
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: '1.3125rem',
    color: '#33434A',
    '@media screen and (min-width: 1200px)' : {
      fontSize: '1.25rem',
      lineHeight: '1.875rem',
    }
  },
  categoriesDetailTiltlePrimary:{
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: '1.3125rem',
    color: '#33434A',
    '@media screen and (min-width: 1200px)' : {
      fontSize: '1.5rem',
      lineHeight: '2.25rem',
      marginTop:'2rem',

    }
  },
  categoriesDetailSubtitleTiltle:{
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1.3125rem',
    letterSpacing: '0.02em',
    color: '#33434A',
    marginTop:'0.5rem',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    '@media screen and (min-width: 1200px)' : {
      fontSize: '0.9375rem',
      lineHeight: '1.375rem',
      marginTop:'0.75rem',
    }
  },
  categoriesDetailSubtitlePrimary:{
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1.3125rem',
    letterSpacing: '0.02em',
    color: '#33434A',
    marginTop:'0.5rem',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    '@media screen and (min-width: 1200px)' : {
      fontSize: '0.9375rem',
      lineHeight: '1.375rem',
      marginTop:'0.75rem',
    }
  },
  imgContainer: {
    width: '100%',
    height: '100%',
    borderRadius:'0.625rem'

  }
}));
